import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { DropdownservicesService } from '../../../../../Services/Apis/Dropdownservices/dropdownservices.service';
import { FrontpageService } from '../../../../../inputfileds/form_services/collegemanagement/frontpage.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { CommonModule } from '@angular/common';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { DynamicFormQuestionComponent } from '../../../../../inputfileds/dynamic-form-question/dynamic-form-question.component';
import { QuestionControlService } from '../../../../../inputfileds/form_services/question-control.service';
import { ApiservicesService } from '../../../../../Services/Apis/apiservices.service';
import { Observable } from 'rxjs';
import { TranslateDirective } from '../../../../Utilites/Directives/translate.directive';

export interface bannersModel {
  image_name: string;
  visible_from: any;
  visible_until: any;
  organization: number;
  image_url: File | null;
}

@Component({
  selector: 'app-addbanners',
  imports: [
    ReactiveFormsModule,
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatDividerModule,
    DynamicFormQuestionComponent,
    MatIconModule,
    TranslateDirective,
  ],
  templateUrl: './addbanners.component.html',
  styleUrl: './addbanners.component.scss',
  providers: [
    QuestionControlService,
    ApiservicesService,
    DropdownservicesService,
  ],
})
export class AddbannersComponent {
  questions: any[] = [];
  questions$: Observable<any[]> | null = null;
  bannersForm!: FormGroup;
  datesend!: bannersModel;
  bannersdata: any = {};
  imageuploaddata: any = {};
  url: string | ArrayBuffer | null | undefined;
  editflag: boolean = false;
  fileName: string | null = null;
  selectedImageUrl: string | ArrayBuffer | boolean | null = null;
  file!: File | null;
  imagePath = this.apiservice.environmentPath;

  constructor(
    private dialogRef: MatDialogRef<AddbannersComponent>,
    private dropdownservice: DropdownservicesService,
    private Bannersservices: FrontpageService,
    private qcs: QuestionControlService,
    private apiservice: ApiservicesService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cdr: ChangeDetectorRef
  ) {
    {
      this.questions$ = this.Bannersservices.getBannersForm();
      this.questions$?.subscribe((q) => {
        return (this.questions = q);
      });
      if (data) {
        this.fileName = this.data.bannerData?.image_name || null;
        this.selectedImageUrl = this.data.bannerData?.image_url
          ? `${this.apiservice.environmentPath}/${this.data.bannerData.image_url}`
          : null;
      }
    }
  }

  ngOnInit(): void {
    this.bannersForm = this.qcs.toFormGroup([]);
    this.bannersForm.addControl(
      'image_name',
      new FormControl(this.data.bannerData?.image_name || '')
    );
    this.bannersForm.addControl(
      'image_url',
      new FormControl(this.data.bannerData?.image_url || null)
    ); // Ensure existing image_url is used
    this.bannersForm.addControl(
      'start_date',
      new FormControl(this.data.bannerData?.visible_from || '')
    );
    this.bannersForm.addControl(
      'end_date',
      new FormControl(this.data.bannerData?.visible_until || '')
    );
  }

  onSubmit() {
    const visibleFrom = new Date(
      this.bannersForm.value.start_date
    ).toISOString();
    const visibleUntil = new Date(
      this.bannersForm.value.end_date
    ).toISOString();

    const formData = new FormData();
    formData.append('image_name', this.bannersForm.value.image_name);
    formData.append('visible_from', visibleFrom);
    formData.append('visible_until', visibleUntil);
    formData.append('website_id', this.data.websiteId);
    formData.append('website_page_id', this.data.pageId);

    // Include selected image or existing image
    if (this.file) {
      formData.append('image_url', this.file);
    } else if (this.selectedImageUrl) {
      formData.append('image_url', this.selectedImageUrl as string);
    } else {
      console.error('No image selected and no existing image URL found.');
      return;
    }

    formData.append('type', 'homepage90');
    if (this.data?.bannerData?.id) {
      this.updateApi(this.data?.bannerData?.id, formData);
    } else {
      this.createAPi(formData);
    }
  }

  createAPi(formData: FormData) {
    const endpoint = this.data.createApiEndpoint;
    console.log('formData', formData);
    this.apiservice.createBanners(endpoint, formData).subscribe(
      (res: any) => {
        if (res.code === 200 && res.status === true) {
          this.bannersForm.reset();
          this.dialogRef.close(true);
        } else {
          alert(res.message);
          console.error('Error:', res.message || 'Unknown error');
        }
      },
      (error) => {
        alert(error);
        console.error('API Error:', error);
      }
    );
  }

  updateApi(id: number, formData: FormData) {
    const endpoint = `${this.data.updateApiEndpoint}`;
    this.apiservice.updateBanners(endpoint, id, formData).subscribe(
      (res: any) => {
        if (res.code === 200 && res.status === true) {
          this.bannersForm.reset();
          this.dialogRef.close(true);
        } else {
          alert(res.message);
          console.error('Error:', res.message || 'Unknown error');
        }
      },
      (error) => {
        alert(error.message);
        console.error('API Error during update:', error.message);
      }
    );
  }

  imageInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files?.length) {
      this.file = input.files[0]; // Store the file
      const reader = new FileReader();

      reader.onload = (e) => {
        this.selectedImageUrl = e.target?.result as string;
        this.cdr.detectChanges(); // Force UI update
      };

      reader.readAsDataURL(this.file);
    } else {
      console.error('No file selected.');
      this.file = null;
      this.selectedImageUrl = null;
    }
  }

  closeDialog(event: any) {
    document
      .getElementsByClassName('animate__animated')[0]
      .classList.remove('animate__fadeIn');
    document
      .getElementsByClassName('animate__animated')[0]
      .classList.add('animate__fadeOut');
    this.dialogRef.close(event);
  }
}
